import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(theme => ({
  addressSectionTitle: {
    font: "700 16px/24px Manrope",
    color: "#465869"
  },
  error: {
    font: "500 14px Manrope",
    color: "#D92D20",
    display: "flex",
    alignItems: "center"
  }
}));

export default styles;
